export default __webpack_public_path__ + "static/media/bank.22fdb9fe.svg";